import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { paths } from '@/app/router/paths';
import { TrackingReportPopulated } from '@/features/projects/kpi-tracking-entry/api/get-tracking-reports';
import { RequestTrackingButton } from '@/features/projects/kpi-tracking-entry/components/request-tracking-button';
import { TrackingReportDialog } from '@/features/projects/kpi-tracking-entry/components/tracking-report-dialog';
import { TrackingReportsView } from '@/features/projects/kpi-tracking-entry/components/tracking-report-history-hub';
import { NavigationButton } from '@/features/projects/project-details/components/navigation-button';
import { ProjectDetails } from '@/features/projects/shared/api/get-project-details';
import PlusIcon from '@/shared/assets/plus.svg?react';
import { Section } from '@/shared/components/section/section';
import {
  SectionHeader,
  SectionTitle,
  SectionActions,
} from '@/shared/components/section/section-header';
import { Button } from '@/shared/components/ui/button';
import { ProjectKpi } from '@/shared/types/api';

export const ProjectDetailsTrackingReportHistory = ({
  project,
  kpis,
}: {
  project: ProjectDetails;
  kpis: ProjectKpi[];
}) => {
  const { t } = useTranslation('project', { keyPrefix: 'TrackingReports' });

  const [trackingReportFormOpen, setTrackingReportFormOpen] = useState(false);

  const [currentReport, setCurrentReport] = useState<
    TrackingReportPopulated | undefined
  >(undefined);

  const isContractor = project.type === 'subproject_contractor';
  const isClient = project.type === 'subproject_client';

  const navigate = useNavigate();

  return (
    <>
      <Section>
        <SectionHeader>
          <SectionTitle className="cursor-pointer">{t('title')}</SectionTitle>
          <SectionActions>
            {/* TODO implement this AND its RLS */}
            {isContractor && (
              <Button
                variant={'greenGradient'}
                btnType="secondary"
                onClick={() => {
                  setTrackingReportFormOpen(true);
                }}
              >
                <PlusIcon />
                {t('add_report')}
              </Button>
            )}
            {isClient && (
              <RequestTrackingButton
                projectId={project.id}
                orgId={project.org_id}
              />
            )}
            <NavigationButton
              onClick={() => {
                navigate(
                  paths.projects.details.trackingReportHistory.getHref(
                    project.id.toString(),
                  ),
                );
              }}
            />
          </SectionActions>
        </SectionHeader>
        {project && (
          <TrackingReportsView
            project={project}
            setTrackingReportFormOpen={setTrackingReportFormOpen}
            setCurrentReport={setCurrentReport}
            searchQuery=""
            limit={10}
          />
        )}
      </Section>
      {project && (
        <TrackingReportDialog
          project={project}
          kpis={kpis}
          isOpen={trackingReportFormOpen}
          onClose={() => {
            setTrackingReportFormOpen(false);
            setCurrentReport(undefined);
          }}
          trackingReport={currentReport}
          editMode={!!currentReport}
          isContractor={isContractor}
        />
      )}
    </>
  );
};
